import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultLoginComponent } from './components';
import { CanDeactivateLoginService, CanActiveLoginService } from './services/guard';

const routes: Routes = [
  {
    path: '',
    component: DefaultLoginComponent,
    canActivate: [CanActiveLoginService],
    canDeactivate: [CanDeactivateLoginService]
  },
  // TODO definir ruta para indicar un nombre de dashbaord erroneo 404
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
